<template>
    <div class="preview">
        <iframe :src="getIframUrl" width="100%" height="100%" />
    </div>
</template>

<script>
export default {
    name: "Preview",
    created() {
        console.log(this.$route.query);
    },
    computed: {
        getIframUrl() {
            const url = this.$route.query.src;
            const fileExtension = url?.slice(((url.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();

            if (fileExtension !== "pdf") {
                return `https://view.officeapps.live.com/op/view.aspx?src=${this.getFileUrl(url)}`;
            } else {
                return this.getFileUrl(url);
            }
        },
    },

    methods: {
        getFileUrl(url) {
            let formatterUrl = "";
            if (process.env.NODE_ENV === "development") {
                formatterUrl = "https://dyyun.e-class.me/" + url;
            } else {
                formatterUrl = `${window.location.origin}/${url}`;
            }

            return formatterUrl;
        },
    },
};
</script>

<style lang="scss" scoped>
.preview {
    height: 100vh;
    width: 100vw;
    overflow: hidden;
}
</style>
